import type { TFunction } from 'i18next'
import type { CddsForm } from '@/lib/api-client'
import { cddsTitleI18nKey } from '@/lib/cdds-rules'

export type CddsParagraphItem = string | { id: string; text: string }

export function cddsFormTitle(t: TFunction, formCode: string, serverTitle: string): string {
  return t(cddsTitleI18nKey(formCode), { defaultValue: serverTitle })
}

export function cddsParagraphDisplayText(item: CddsParagraphItem): string {
  return typeof item === 'string' ? item : item.text
}

export function normalizeCddsParagraphs(form?: CddsForm): CddsParagraphItem[] {
  return (form?.paragraphs ?? []) as CddsParagraphItem[]
}
